export const PaymentStep = {
  PAYMENT_PLAN_LINE: "PAYMENT_PLAN_LINE",
  PAYMENT_PLAN: "PAYMENT_PLAN",
};
